import { FunctionComponent } from "react";
import { History as HistoryIcon } from "lucide-react";
import { WalletInterface } from "../../models/Wallet";
import { formatAssetWithSymbol } from "../../utils/decimal";
import './WalletCard.scss';

interface WalletCardProps {
    wallet: WalletInterface;
}

const WalletCard: FunctionComponent<WalletCardProps> = ({ wallet }) => {
    return (
        <div className="wallet-list-card">
            <h3>
                <div className="meta">
                    <strong title={wallet.organization?.organizationName}>
                        {wallet.organization?.organizationName || wallet.asset.symbol}
                    </strong>
                    <small>{wallet.nickname || "wallet"}</small>
                </div>
            </h3>

            <span className="amount">
                {formatAssetWithSymbol(wallet.balance, wallet.asset.symbol)}
            </span>
            <small className="label">Saldo disponivel</small>

            <button className="btn-pill ghost">
                <HistoryIcon size={13} /> Ver historico
            </button>
        </div>
    );
};

export default WalletCard;